define('uikit/collections/table',['require','exports','module','underscore','backbone','marionette','../channel','../helper/browser','../extra/key.codes','../elements/dropdown','./table.row','./table.cell','../mixins/component.mixin','../templates','../extra/extend.util'],function(require, exports, module) {
  var _ = require('underscore');
  var Backbone = require('backbone');
  var Mn = require('marionette');
  var channel = require('../channel');
  var browser = require('../helper/browser');
  var CODES = require('../extra/key.codes');
  var Dropdown = require('../elements/dropdown');
  var RowView = require('./table.row');
  var CellView = require('./table.cell');
  var ComponentMixin = require('../mixins/component.mixin');
  var Templates = require('../templates');
  var ExtendUtil = require('../extra/extend.util');

  var DATA_FIELD = 'data';
  var SORT_FIELD = 'sort';
  var FORMATTER_FIELD = 'formatter';

  var SINGLE_SELECTION = 'single';
  var MULTI_SELECTION = 'multi';
  var MANUAL_SELECTION = 'manual';
  var ASCENDING = 'ascending';
  var DESCENDING = 'descending';

  var HeaderCellView = Mn.ItemView.extend(ComponentMixin).extend({
    tagName: 'th',
    template: Templates.UIKit['table.header'],

    internalViewOptions: {
      columnHeaderChildView: function() {
        return _.extend(
          {
            type: this.model.get('headerChildView'),
          },
          this.model.get('headerChildViewOptions')
        );
      },
    },

    events: {
      click: function() {
        this.triggerMethod('press');
      },
    },

    modelEvents: {
      change: 'render',
    },

    options: {
      sort: null,
      scope: 'col',
      hasHeaderChildView: false,
    },

    forceUpdate: {
      sort: true,
    },

    initialize: function() {
      ComponentMixin.initialize.apply(this, arguments);

      _.extend(this.options, {
        hasHeaderChildView: this.getOption('model') ? !!this.getOption('model').get('headerChildView') : false,
      });
    },

    updateAttributes: function() {
      var properDir = this.getOption('sort') == Table.ASCENDING ? Table.DESCENDING : Table.ASCENDING;

      this.addClass(this.model.get('align') + ' aligned', !!this.model.get('align'))
        .addClass('sortable', this.getOption('sortable') && !!this.model.get('sortable'))
        .addClass('sorted ' + properDir, this.getBoolOption('sort'))
        .addClass('collapsing', this.model.get('collapsing'))
        .updateElementAttributes({ scope: this.getOption('scope') });
    },

    onBeforeRender: function() {
      var model = this.model,
        view = model.get('view');
      if (view) {
        view.$el.detach();
      }
    },

    onRender: function() {
      var model = this.model,
        view = model.get('view');

      if (view) {
        if (!view._isRendered) {
          view.render();
        }
        this.$el.append(view.$el);
      }
    },
  });

  var TableRowHeaderModel = Backbone.Model.extend({});

  var TableRowHeader = Mn.ItemView.extend({
    tagName: 'tr',

    className: 'group header',

    serializeData: function() {
      return {
        columns: this.tableView.columns.length,
        text: this.model ? this.model.get('text') : '',
      };
    },

    template: Templates.UIKit['table.row.header'],
  });

  var EmptyRowView = Mn.ItemView.extend({
    tagName: 'tr',
    className: 'empty',
    serializeData: function() {
      return {
        columns: this._parent.columns.length,
        text: this._parent.getOption('emptyText'),
      };
    },
    template: Templates.UIKit['table.empty'],
  });

  var Table = Mn.CompositeView.extend(ComponentMixin).extend({
    className: 'ui table',

    tagName: 'table',

    template: Templates.UIKit['table'],

    options: {
      visible: true,
      collection: null,
      columns: null,
      inverted: false,
      caption: '',
      showCaption: false,
      color: '',
      size: null,
      sortable: true,
      celled: false,
      borderless: false,
      basic: false,
      striped: false,
      unstackable: browser.isIE() == '9' || false,
      tabletStackable: false,
      definition: false,
      sortField: null,
      compact: false,
      value: null,
      padded: false,
      sortDir: ASCENDING,
      emptyText: 'No entries.',
      headless: false,
      toggleSelection: false,
      selection: null, // single or multi,
      selectable: false,
      focusable: true,
      rowLinkFormatter: null,
      rowLinkTarget: '_self',
      fixedHeader: false,
      fixedHeaderTarget: document,
      fixedHeaderTopOffset: 0,
      fixedHeaderBackground: 'white',
      link: false,
      itemCount: false,
      // will focus cause selection
      selectOnFocus: false,
      invertColumnChildViewsOnActive: false,
      invertColumnChildViewsOnFocus: false,
      attached: false,
    },

    forceUpdate: {
      caption: true,
      showCaption: true,
      collection: true,
      columns: true,
      emptyText: true,
      headless: true,
      toggleSelection: true,
      selectable: true,
      focusable: true,
      rowLinkFormatter: true,
      rowLinkTarget: true,
      itemCount: true,
    },

    bindings: {
      // sortField : 'sortField',
      // sortDir   : 'sortDir',
    },

    emptyView: EmptyRowView,
    childView: RowView,

    // keep for legacy support
    childViewOptions: function() {
      return {};
    },

    buildChildView: function(child, ChildViewClass, childViewOptions) {
      childViewOptions = _.extend(
        {
          tableView: this,
        },
        childViewOptions
      );
      ChildViewClass = ExtendUtil.extendClassBehaviors(ChildViewClass, childViewOptions);
      return Mn.CompositeView.prototype.buildChildView.call(this, child, ChildViewClass, childViewOptions);
    },

    getChildView: function(model) {
      if (model instanceof TableRowHeaderModel) {
        return TableRowHeader;
      }
      return Mn.CompositeView.prototype.getChildView.apply(this, arguments);
    },

    headerCellView: HeaderCellView,
    childViewContainer: '@ui.childrenContainer',
    childViewEventPrefix: 'row',

    ui: {
      childrenContainer: '> tbody',
      header: '> thead > tr:first-child',
      responsiveHeader: '> thead > tr.responsive.sort',
      itemCount: '> tfoot .item.count',
    },

    initialize: function() {
      ComponentMixin.initialize.apply(this, arguments);
      this.columns = new Backbone.Collection(this.getOption('columns') || [], { model: ColumnModel });

      // clean up the headerView
      this.once('destroy', function() {
        if (this.headerView) {
          this.headerView.destroy();
        }
      }).on(
        'change:collection',
        function() {
          if (this.itemCount) {
            // unbind the previous event
            this.off('render', this._updateItemCountText, this);
            this.initializeItemCountUpdater();
          }
        },
        this
      );

      if (this.itemCount) {
        this.initializeItemCountUpdater();
      }

      this.setupSortingDropdown();
    },

    initializeItemCountUpdater: function() {
      if (this.collection) {
        this.listenTo(this.collection, 'add remove reset', this._updateItemCountText);
      }
      this.on('render', this._updateItemCountText, this);
      if (this.isRendered) {
        this._updateItemCountText();
      }
    },

    _updateItemCountText: function() {
      var count = this.collection ? this._filteredSortedModels().length : 0,
        text = count == 1 ? '1 item' : count + ' items';

      if (this.ui.itemCount) {
        this.ui.itemCount.text(text);
      }
    },

    onBeforeDestroyCollection: function() {
      this.emptyView = null;
      this.options.emptyView = null;
    },

    setupSortingDropdown: function() {
      this.sortColumns = new Backbone.Collection([], { model: SortColumnModel });

      // Instantiate new dropdown
      this.dropdown = new Dropdown({
        collection: this.sortColumns,
        fluid: true,
        placeholder: 'Sort By',
        visible: this.getOption('sortable'),
      });

      this.dropdown.childBindings.text = 'description';

      // Create sortable column descriptions
      this.listenTo(this.columns, 'add remove reset change update', _.debounce(this._setupSortingColumns));

      this._setupSortingColumns();

      this.listenTo(this.dropdown, 'change:value', function(dd, value) {
        if (value) {
          this.sortDir = value.get('sortDir');
          this.sortField = this.getColumnModelSortField(value);
        }
      });
    },

    _setupSortingColumns: function() {
      var sortableColumns = this.columns.filter(function(m) {
          return m.get('sortable') && m.get('visible') !== false;
        }),
        sc = this.sortColumns;

      sc.reset([]);

      if (this.getOption('sortable')) {
        for (var s = 0, len = sortableColumns.length; s < len; s++) {
          var attributes = _.clone(sortableColumns[s].attributes);

          sc.add(new SortColumnModel(_.extend({}, attributes, { sortDir: 'ascending' })));
          sc.add(new SortColumnModel(_.extend({}, attributes, { sortDir: 'descending' })));
        }
      }

      this._syncSortToDropdown();

      this._changeResponsiveHeaderVisibility();
    },

    _syncSortToDropdown: function() {
      var selected = null;

      selected = this.sortColumns.find(function(column) {
        return column.get('sortDir') == this.sortDir && this.getColumnModelSortField(column) == this.sortField;
      }, this);

      this.dropdown.value = selected;
    },

    _changeResponsiveHeaderVisibility: function() {
      if (this.isRendered) {
        if (!this.getOption('sortable') || !this.sortColumns.length || this.getOption('headless')) {
          this.ui.responsiveHeader.addClass('hidden');
        } else {
          this.ui.responsiveHeader.removeClass('hidden');
        }
      }
    },

    onBeforeAddChild: function(childView) {
      childView.tableView = this;
    },

    updateAttributes: function() {
      var basic = this.getOption('basic');
      var attached = this.getOption('attached');

      this._changeResponsiveHeaderVisibility();

      this.addClass('borderless', this.getBoolOption('borderless'))
        .addClass('inverted', this.getBoolOption('inverted'))
        .addClass('definition', this.getBoolOption('definition'))
        .addClass('unstackable', this.getBoolOption('unstackable'))
        .addClass('striped', this.getBoolOption('striped'))
        .addClass('padded', this.getBoolOption('padded'))
        .addClass('sortable', this.getBoolOption('sortable') && !!this.columns.where({ sortable: true }).length)
        .addClass('celled', this.getBoolOption('celled'))
        .addClass('compact', this.getBoolOption('compact'))
        .addClass(this.getOption('color'), this.getBoolOption('color'))
        .addClass(this.getOption('size'), this.getBoolOption('size'))
        .addClass((basic == 'very' ? basic + ' ' : '') + 'basic', this.getBoolOption('basic'))
        .addClass('selectable', this.getBoolOption('selectable'))
        .addClass('link', this.getBoolOption('link'))
        .addClass('tablet stackable', this.getBoolOption('tabletStackable') && !this.getBoolOption('unstackable'))
        .addClass((_.isString(attached) ? attached + ' ' : '') + 'attached', this.getBoolOption('attached'));
    },

    _syncSortToHeaders: function() {
      if (!this.getOption('headless')) {
        this.headerView.children.each(function(colCellView) {
          var sortField = this.getColumnModelSortField(colCellView.model);
          if (sortField && sortField == this.sortField) {
            colCellView.sort = this.sortDir;
          } else {
            colCellView.sort = null;
          }
        }, this);

        this._syncSortToDropdown();
      }
    },

    getColumnModelSortField: function(model) {
      var sortField = model.get(SORT_FIELD);
      return sortField ? sortField : model.get(DATA_FIELD);
    },

    isSelected: function(model) {
      if (!this.selection) {
        return false;
      } else if (this.selection && this.selection != MULTI_SELECTION) {
        if (model && this.value) {
          if (!model.id && !this.value.id) {
            return model.cid == this.value.cid;
          } else {
            return model.id == this.value.id || model == this.value;
          }
        } else {
          return model == this.value;
        }
      } else if (this.selection == MULTI_SELECTION && this.value instanceof Backbone.Collection) {
        return !!(this.value.get(model) || this.value.contains(model));
      }
      return false;
    },

    onRowPress: function(rowView) {
      var selection = this.getOption('selection'),
        model = rowView.model;

      // If the table has links attached to the rows
      if (this.getOption('rowLinkFormatter') || rowView.link) {
        // Trigger the first available link
        var linkEl = rowView.$el.find('a').get(0);
        if (linkEl) {
          linkEl.click();
        }
      }

      if (selection && selection != MULTI_SELECTION) {
        if (this.getOption('toggleSelection') === true && this.isSelected(model)) {
          this.value = null;
        } else {
          this.value = model;
        }
      } else if (selection == MULTI_SELECTION) {
        if (this.value instanceof Backbone.Collection) {
          if (this.isSelected(model)) {
            if (this.getOption('toggleSelection') === true) {
              this.value.remove(this.value.get(model));
            }
          } else {
            this.value.push(model);
          }
        } else {
          var newSelCollection = new Backbone.Collection();
          newSelCollection.push(model);
          this.value = newSelCollection;
        }
      }
    },

    onRowFocus: function() {
      if (this.getBoolOption('selectOnFocus')) {
        this.onRowPress.apply(this, arguments);
      }
    },

    getSelectedRow: function() {
      if (this.value instanceof Backbone.Model) {
        return this.getRow(this.value);
        return this.children.findByModel(this.value);
      } else if (this.value instanceof Backbone.Collection) {
        return this.getRows(this.value);
      }
    },

    getRow: function(model) {
      if (!(model instanceof Backbone.Model)) {
        return;
      }
      return this.children.findByModel(model);
    },

    getRows: function(collection) {
      if (!(collection instanceof Backbone.Collection)) {
        return;
      }
      return collection.map(function(model) {
        return this.children.findByModel(model);
      }, this);
    },

    onHeaderCellPress: function(cellView) {
      if (!this.getOption('sortable') || !cellView.model.get('sortable')) {
        return;
      }
      var changedField = this.sortField == this.getColumnModelSortField(cellView.model);
      this.sortField = this.getColumnModelSortField(cellView.model);
      if (!changedField) {
        this.sortDir = Table.ASCENDING;
      } else {
        if (this.sortDir == Table.ASCENDING) {
          this.sortDir = Table.DESCENDING;
        } else if (this.sortDir == Table.DESCENDING) {
          this.sortDir = Table.ASCENDING;
        }
      }
    },

    onChangeValue: function(view, value, oldValue) {
      if (oldValue instanceof Backbone.Model) {
        oldValue.trigger('table:row:selection:changed');
      }
      if (value instanceof Backbone.Model) {
        value.trigger('table:row:selection:changed');
      }
      if (oldValue instanceof Backbone.Collection) {
        this.stopListening(oldValue);
        oldValue.each(function(oldModel) {
          oldModel.trigger('table:row:selection:changed');
        });
      }
      if (value instanceof Backbone.Collection) {
        this.listenTo(value, 'add remove reset change update', function(change, ev) {
          if (change instanceof Backbone.Model) {
            _.defer(
              _.bind(function() {
                change.trigger('table:row:selection:changed');
                var modelInCollection = this.collection.get(change);
                if (modelInCollection && modelInCollection !== change) {
                  modelInCollection.trigger('table:row:selection:changed');
                }
              }, this)
            );
          } else if (change instanceof Backbone.Collection && ev.previousModels) {
            _.each(
              ev.previousModels,
              function(model) {
                _.defer(
                  _.bind(function() {
                    model.trigger('table:row:selection:changed');
                    var modelInCollection = this.collection.get(model);
                    if (modelInCollection && modelInCollection !== model) {
                      modelInCollection.trigger('table:row:selection:changed');
                    }
                  }, this)
                );
              },
              this
            );
          }
        });
        value.each(function(newSelModel) {
          newSelModel.trigger('table:row:selection:changed');
        });
      }
    },

    onFirstRender: function() {
      var self = this;
      this.onChangeValue(this, this.value, null);
      this.bindColumnCollection();
      if (this.getOption('fixedHeader')) {
        $(this.getOption('fixedHeaderTarget')).on('scroll.table', _.bind(this._onFixedTargetScroll, this));
        var debouncedFixScroll = _.debounce(function() {
          self._onFixedTargetScroll();
        }, 10);
        $(window).on('resize.table', function() {
          self._resetFixedHeader();
          debouncedFixScroll();
        });
      }
    },

    _onFixedTargetScroll: function() {
      if (!this.headerView) {
        return;
      }

      var target = $(this.getOption('fixedHeaderTarget')),
        taretScrollTop = target.scrollTop(),
        fixedHeaderTopOffset = Number(this.getOption('fixedHeaderTopOffset')) || 0,
        fixedHeaderTopPosition = Number(this.getOption('fixedHeaderTopPosition')),
        clonedEl = null,
        headerOffset = (this._clonedHeaderEl ? this._clonedHeaderEl.offset() : this.headerView.$el.offset()) || {
          top: 0,
          left: 0,
        };

      if (taretScrollTop > headerOffset.top - fixedHeaderTopOffset) {
        if (!this.$el.is(':visible')) {
          return;
        }

        if (this._fixedHeader) {
          return;
        }

        headerOffset = this._fixedTable ? this._fixedTable.offset() : this.$el.offset();

        this._fixedHeader = true;

        this._clonedHeaderEl = this.headerView.$el.clone();

        this._fixedTable = $(document.createElement('table'))
          .css('table-layout', 'fixed')
          .attr('class', this.$el.attr('class'))
          .addClass('fixed')
          .appendTo(target.get(0) === document ? document.body : target)
          .attr('style', this.$el.attr('style'))
          .css({
            position: 'fixed',
            width: this.$el.outerWidth(),
            left: headerOffset.left,
            marginTop: '0px',
            zIndex: 100,
            background: this.getOption('fixedHeaderBackground') || '',
            top:
              (fixedHeaderTopPosition != null && !_.isNaN(fixedHeaderTopPosition)
                ? fixedHeaderTopPosition
                : fixedHeaderTopOffset) + 'px',
          });

        var clonedTh = this._clonedHeaderEl.find('th'),
          th = this.headerView.$('th');

        for (var i = 0, len = th.length, w; i < len; i++) {
          w = th.eq(i).outerWidth();
          th.eq(i).css({
            width: w,
          });
          clonedTh.eq(i).css({
            minWidth: w,
          });
        }

        var thead = $(document.createElement('thead')).appendTo(this._fixedTable);

        this._clonedHeaderEl.insertAfter(this.headerView.$el);

        this.headerView.$el.appendTo(thead);
      } else {
        this._resetFixedHeader();
      }
    },

    _resetFixedHeader: function() {
      if (!this._fixedHeader) {
        return;
      }

      this._fixedHeader = false;
      if (this._clonedHeaderEl) {
        this.headerView.$el.insertAfter(this._clonedHeaderEl);
        this._clonedHeaderEl.remove();
        this._clonedHeaderEl = null;
      }
      if (this._fixedTable) {
        this._fixedTable.remove();
        this._fixedTable = null;
      }

      if (this.headerView) {
        this.headerView.$el.find('th').css('width', '');
      }
    },

    bindColumnCollection: function() {
      var columns = this.columns;

      if (columns) {
        this.listenTo(
          columns,
          'add remove reset sort update change:visible',
          _.debounce(function() {
            this._syncSortToHeaders();
            this._renderChildren();
          }, 1)
        );
        this.listenTo(
          columns,
          'change:visible',
          _.debounce(function() {
            this.headerView._renderChildren();
          })
        );
      }

      this.once('change:columns', function() {
        if (columns) {
          this.stopListening(columns);
        }
        this.bindColumnCollection();
      });
    },

    lockCellWidth: function(model, column) {
      var row = this.children.findByModel(model),
        columnIndex = this.columns.indexOf(column);

      if (row) {
        var td = row.$('td:eq(' + columnIndex + ')');
        td.width(td.width());
      }
      return this;
    },

    unlockCellWidth: function(model, column) {
      var row = this.children.findByModel(model),
        columnIndex = this.columns.indexOf(column);

      if (row) {
        row.$('td:eq(' + columnIndex + ')').css('width', '');
      }
      return this;
    },

    detachColumnViews: function() {
      if (this.columns) {
        this.columns.each(function(column) {
          var view = column.get('view');
          if (view) {
            view.$el.detach();
          }
        });
      }
    },

    onRender: function() {
      if (!this.headerView && !this.getOption('headless')) {
        var HeaderCellView = this.getOption('headerCellView');

        this.headerView = new Mn.CollectionView({
          tagName: 'tr',
          collection: this.getOption('columns'),
          childView: HeaderCellView,
          childViewOptions: {
            sortable: this.getOption('sortable'),
          },
          childViewEventPrefix: 'cell',
          filter: function(model) {
            return model.get('visible') !== false;
          },
        });

        this.on('change:sortField change:sortDir', this._syncSortToHeaders, this);
        this.listenTo(
          this.headerView,
          'all',
          function(eventName) {
            this.triggerMethod.apply(this, ['header:' + eventName].concat(_.rest(arguments)));
          },
          this
        );
      }

      if (!this.getOption('headless')) {
        this.headerView.setElement(this.ui.header);
        this.headerView.render();
        this._syncSortToHeaders();
      }
    },

    onBeforeRender: function() {
      this.detachColumnViews();
    },

    onHeaderBeforeRender: function() {
      this.detachColumnViews();
    },

    _initialEvents: function() {
      if (this.collection) {
        this.listenTo(this.collection, 'remove', function(model, collection, options) {
          model._destroyAnimation = options.animate;
        });
      }
      Mn.CompositeView.prototype._initialEvents.apply(this, arguments);
    },

    removeChildView: function(view) {
      var args = _.toArray(arguments),
        self = this;

      if (view.model && view.model._destroyAnimation) {
        view.$el.transition({
          animation: view.model._destroyAnimation,
          duration: this.getOption('childViewRemoveDuration') || '0.5s',
          onComplete: function() {
            Mn.CompositeView.prototype.removeChildView.apply(self, args);
          },
        });
        delete view.model._destroyAnimation;
      } else {
        Mn.CompositeView.prototype.removeChildView.apply(self, args);
      }
      return view;
    },

    onBeforeDestroy: function() {
      if (this.getOption('fixedHeader')) {
        $(this.getOption('fixedHeaderTarget')).off('scroll.table');
        $(window).off('resize.table');
      }
      this._resetFixedHeader();
      if (this.columns) {
        this.columns.each(function(column) {
          var view = column.get('view');
          // we have to cleanup any views specified for the table header
          if (view) {
            view.destroy();
          }
        });
      }
    },
  });

  channel.reply('table', function() {
    return Table;
  });

  var ColumnModel = Backbone.Model.extend({
    defaults: {
      text: '',
      data: null,
      align: null,
      sort: null,
      collapsing: false,
      formatter: null,
      visible: true,
      sortable: false,
    },
  });

  var SortColumnModel = Backbone.Model.extend({
    defaults: {
      sortable: true,
      data: null,
      description: '',
      sortDir: Table.ASCENDING,
      text: '',
      type: 'String',
    },

    initialize: function() {
      this.defineDescByType();
    },

    defineDescByType: function() {
      var dirDescription = '',
        init = '',
        end = '',
        text = this.get('text');

      switch (this.get('type').toLowerCase()) {
        case 'date':
          init = 'Oldest';
          end = 'Newest';
          break;
        case 'number':
          (init = '0'), (end = '9');
          break;
        default:
          init = 'A';
          end = 'Z';
      }

      if (this.get('sortDir') == Table.ASCENDING) {
        dirDescription = init + ' to ' + end;
      } else if (this.get('sortDir') == Table.DESCENDING) {
        dirDescription = end + ' to ' + init;
      }

      this.set('description', dirDescription ? text + ' - ' + dirDescription : text);
    },
  });

  Table.ColumnModel = ColumnModel;
  Table.RowView = RowView;
  Table.CellView = CellView;
  Table.HeaderCellView = HeaderCellView;
  Table.EmptyRowView = EmptyRowView;
  Table.RowHeaderView = TableRowHeader;
  Table.RowHeaderModel = TableRowHeaderModel;

  Table.CellView.Table = Table;

  Table.SINGLE_SELECTION = SINGLE_SELECTION;
  Table.MULTI_SELECTION = MULTI_SELECTION;
  Table.MANUAL_SELECTION = MANUAL_SELECTION;
  Table.ASCENDING = ASCENDING;
  Table.DESCENDING = DESCENDING;

  module.exports = Table;
});

